'use client';

import React from 'react';
import { canUseDOM } from '@/app/common/utils/canUseDOM';
import { handleChunkLoadError } from '@/utils/errors.ts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const dynamicImportCatch = (error: Error): { default: () => React.ReactElement<any> } => {
  if (canUseDOM) {
    handleChunkLoadError(error);
  }
  return { default: () => <div /> };
};
